import { isAuthorized } from "./authorized-pages";
import {
  CATALOG_ADMIN_ROLES,
  EMAIL_USER_ROLES,
  SITE_SETTINGS_ROLES,
  normalizeRoleValue,
  roleValuesFromClaims,
} from "./roles";

type Claims = Record<string, unknown> | null | undefined;

export interface AuthPermissions {
  readonly roles: readonly string[];
  hasRole: (role: string) => boolean;
  canManageCatalog: () => boolean;
  canManageSiteSettings: () => boolean;
  canManageInquiries: () => boolean;
  canAccessEmail: () => boolean;
  canAccessPath: (path: string) => boolean;
}

export function createAuthPermissions(...claimSets: Claims[]): AuthPermissions {
  const roles = Array.from(
    new Set(claimSets.flatMap((claims) => roleValuesFromClaims(claims))),
  );
  const normalizedRoles = new Set(roles.map(normalizeRoleValue));
  const hasAnyRole = (allowedRoles: readonly string[]) =>
    allowedRoles.some((role) => normalizedRoles.has(normalizeRoleValue(role)));

  return {
    roles,
    hasRole: (role) => normalizedRoles.has(normalizeRoleValue(role)),
    canManageCatalog: () => hasAnyRole(CATALOG_ADMIN_ROLES),
    canManageSiteSettings: () => hasAnyRole(SITE_SETTINGS_ROLES),
    canManageInquiries: () => hasAnyRole(CATALOG_ADMIN_ROLES),
    canAccessEmail: () => hasAnyRole(EMAIL_USER_ROLES),
    canAccessPath: (path) => isAuthorized(path, roles),
  };
}
